import type { FooterProps } from './FooterProps.d';

import { faFacebook, faLinkedin, faSquareXTwitter } from '@fortawesome/free-brands-svg-icons';
import { Link as FriskLink } from '@hdir/ui/link';
import React from 'react';

import { FontAwesomeIconWrapper } from '../../components/FontAwesomeIconWrapper';
import { HDIR_LOGO_ALT_TEXT } from '/react4xp/overdosefare/constants';


export function Footer({ footerContent }: FooterProps): JSX.Element | null {
	if (!footerContent) return null;

	const iconMap = {
		faSquareXTwitter: faSquareXTwitter,
		faFacebook: faFacebook,
		faLinkedin: faLinkedin,
	};

	// TODO: translate "Følg oss:"

	return (
		<footer className="footer flex flex-col gap-xl bg-surface-neutral-primary px-xl py-xxl text-action-primary md:p-xxxl lg:px-[calc(1rem*9.0625)]">
			<div className="mx-auto flex w-full max-w-content flex-col gap-xl">
				{footerContent.sections && (
					<div className="flex flex-col flex-wrap justify-between gap-xxl sm:flex-row md:gap-0">
						{footerContent.sections.map((section, sectionIndex) => (
							<div className="flex flex-col gap-lg" key={sectionIndex}>
								<h2 className="text-lg font-bold">{section.sectionName}</h2>
								{section.sectionLinks.map((link, linkIndex) => (
									<div key={linkIndex}>
										<FriskLink variant="inverted" className="text-sm leading-[160%] underline-offset-8 hover:cursor-pointer" href={link.href}>
											{link.name}
										</FriskLink>
										{sectionIndex === 0 && linkIndex === section.sectionLinks.length - 1 && footerContent.address && (
											<div className="mt-lg text-sm leading-[160%]">
												<p className="">{footerContent.address.companyName}</p>
												<p className="">{footerContent.address.visitorAddress}</p>
												<p className="">{footerContent.address.mailAddress}</p>
											</div>
										)}
									</div>
								))}
							</div>
						))}
					</div>
				)}
				<div>
					<span className="divider--horizontal" />
					<div className="mt-lg flex w-full flex-col flex-wrap justify-between gap-xl md:flex-row md:gap-0">
						<FriskLink href={footerContent.baseUrl}>
							<img
								alt={HDIR_LOGO_ALT_TEXT}
								className="h-[34px] w-auto"
								src={footerContent.logo}
							/>
						</FriskLink>
						{footerContent.socialMedia.length > 0 && (
							<div className="flex flex-row flex-wrap content-center gap-xs">
								<span className="flex flex-wrap content-center text-md font-bold">Følg oss:</span>
								{footerContent.socialMedia.map(({icon, socialMediaURL}, mediaIndex) => (
									<FriskLink key={mediaIndex} href={socialMediaURL} className="h-8 w-auto">
										{
											icon
												? <FontAwesomeIconWrapper size="sm" icon={iconMap[icon]} className="yep size-full text-icon-action-primary"/>
												: null
										}
									</FriskLink>
								))}
							</div>
						)}
					</div>
				</div>
			</div>
		</footer>
	);
}
